import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldOperatorDropdown } from '@/(routers)/boards/editor/block/definitions/fields/fieldOperatorDropdown';
import { FieldStyledBadgeLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledBadgeLabel';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

const POSITION_OPTIONS = [
    { value: 'UPPER_LEFT', label: '左上' },
    { value: 'UPPER_RIGHT', label: '右上' },
    { value: 'LOWER_LEFT', label: '左下' },
    { value: 'LOWER_RIGHT', label: '右下' },
];

const UNIT_OPTIONS = [
    { value: 'KMPH', label: 'km/h' },
    { value: 'MPS', label: 'm/s' },
];

defineBlock({
    type: 'gps_speed',
    colour: CATEGORIES.gps.color,
    tooltip: 'GPSセンサーから速度を取得します',
    movable: true,
    deletable: true,
    output: 'Number',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                { type: 'image', icon: { src: '/images/block/gps.svg', size: 65 } },
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('GPS', { fontSize: 15, fontWeight: 'bold' }),
                },
                {
                    type: 'field',
                    instance: () => new FieldStyledBadgeLabel('速度'),
                },
                { type: 'label', text: ' ' },
                {
                    type: 'dropdown',
                    name: 'POSITION',
                    rectColour: CATEGORIES.gps.color,
                    options: POSITION_OPTIONS,
                },
                { type: 'label', text: 'で' },
                {
                    type: 'field',
                    name: 'UNIT',
                    instance: () => new FieldOperatorDropdown(UNIT_OPTIONS, 'KMPH', undefined, CATEGORIES.gps.color),
                },
                { type: 'label', text: 'を計測する ' },
            ],
        },
    ],
});
